import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Cloud extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Cloud_1);

    this.speed = 0;
    this.destX = 0;

    this.setOrigin(0);
  }

  reset (spritename, speed, startX, startY, endX, scale) {
    this.setFrame(spritename).setOrigin(0);
    this.speed = speed;
    this.destX = endX;
    this.x = startX;
    this.y = startY;
    this.setScale(scale);
  }

  switchSprite (spritename) {
    this.setFrame(spritename).setOrigin(0);
    this.destX = -Math.floor(this.displayWidth);
  }

  tick (dt) {
    this.x -= this.speed * dt;
  }
}